import { render, staticRenderFns } from "./CreateDeck.vue?vue&type=template&id=63214408&"
import script from "./CreateDeck.vue?vue&type=script&lang=js&"
export * from "./CreateDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateDeck.vue"
export default component.exports